import { render, staticRenderFns } from "./VChatRoom.vue?vue&type=template&id=0539f32e&"
import script from "./VChatRoom.vue?vue&type=script&lang=js&"
export * from "./VChatRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0539f32e')) {
      api.createRecord('0539f32e', component.options)
    } else {
      api.reload('0539f32e', component.options)
    }
    module.hot.accept("./VChatRoom.vue?vue&type=template&id=0539f32e&", function () {
      api.rerender('0539f32e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VChatRoom.vue"
export default component.exports